import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=9b10168e&scoped=true&"
var script = {}
import style0 from "./Main.vue?vue&type=style&index=0&id=9b10168e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b10168e",
  null
  
)

export default component.exports